var map = {
	"./de/general3/slide3.svg": 512458,
	"./en/general3/slide3.svg": 575654,
	"./es/general3/slide3.svg": 223335,
	"./fr/general3/slide3.svg": 343647,
	"./nl/general3/slide3.svg": 448873,
	"./pt/general3/slide3.svg": 710891
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 722196;